// Comprehensive coupon data with 200+ items per category
// Discount rates: Retail/Fashion = 5%, Food & Dining = 6%, Others = 3%

const DISCOUNT_RATES = {
    fashion: 5,
    food: 6,
    entertainment: 3,
    travel: 3,
    ecommerce: 3,
    beauty: 3,
    fitness: 3,
    home: 3,
    education: 3,
    utility: 3
};

// Price range: ₹500 to ₹10,000
const PRICE_POINTS = [500, 750, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000, 6000, 7000, 8000, 9000, 10000];

// Seeded shuffle function for consistent randomization
function seededShuffle(array, seed) {
    const arr = [...array];
    let currentSeed = seed;
    
    for (let i = arr.length - 1; i > 0; i--) {
        currentSeed = (currentSeed * 9301 + 49297) % 233280;
        const j = Math.floor((currentSeed / 233280) * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
}

function generateCoupons(brands, categoryKey, discountRate) {
    const coupons = [];
    let id = 0;
    
    // Shuffle brands for variety
    const shuffledBrands = seededShuffle(brands, categoryKey.charCodeAt(0) * 1000);
    
    shuffledBrands.forEach((brand, brandIndex) => {
        // Shuffle price points for each brand
        const shuffledPrices = seededShuffle(PRICE_POINTS, brandIndex * 100 + categoryKey.length);
        
        shuffledPrices.forEach((price, priceIndex) => {
            const saved = Math.round((price * discountRate) / 100);
            coupons.push({
                id: `${categoryKey}-${++id}`,
                brand: brand.name,
                voucher: `${brand.name} ₹${price.toLocaleString('en-IN')} Gift Card`,
                category: brand.category,
                categoryKey: categoryKey,
                price: `₹${price.toLocaleString('en-IN')}`,
                priceValue: price,
                discount: `${discountRate}% OFF`,
                discountRate: discountRate,
                saved: `₹${saved}`,
                savedValue: saved,
                image: `/coupons/${categoryKey}/${brand.slug}.png`,
                gradient: brand.gradient,
                initial: brand.name.charAt(0).toUpperCase()
            });
        });
    });
    
    // Final shuffle of all coupons for maximum randomness
    return seededShuffle(coupons, categoryKey.length * 7777);
}

// Fashion brands
const fashionBrands = [
    { name: 'Nike', slug: 'nike', category: 'Retail / Fashion', gradient: ['#ff6b9d', '#c84b7e'] },
    { name: 'Adidas', slug: 'adidas', category: 'Retail / Fashion', gradient: ['#ff6b9d', '#c84b7e'] },
    { name: 'Puma', slug: 'puma', category: 'Retail / Fashion', gradient: ['#ff6b9d', '#c84b7e'] },
    { name: 'Zara', slug: 'zara', category: 'Retail / Fashion', gradient: ['#ff6b9d', '#c84b7e'] },
    { name: 'H&M', slug: 'hm', category: 'Retail / Fashion', gradient: ['#ff6b9d', '#c84b7e'] },
    { name: "Levi's", slug: 'levis', category: 'Retail / Fashion', gradient: ['#ff6b9d', '#c84b7e'] },
    { name: 'Lifestyle', slug: 'lifestyle', category: 'Retail / Fashion', gradient: ['#ff6b9d', '#c84b7e'] },
    { name: 'Shoppers Stop', slug: 'shoppers-stop', category: 'Retail / Fashion', gradient: ['#ff6b9d', '#c84b7e'] },
    { name: 'Pantaloons', slug: 'pantaloons', category: 'Retail / Fashion', gradient: ['#ff6b9d', '#c84b7e'] },
    { name: 'Westside', slug: 'westside', category: 'Retail / Fashion', gradient: ['#ff6b9d', '#c84b7e'] },
    { name: 'Decathlon', slug: 'decathlon', category: 'Retail / Fashion', gradient: ['#ff6b9d', '#c84b7e'] },
    { name: 'FabIndia', slug: 'fabindia', category: 'Retail / Fashion', gradient: ['#ff6b9d', '#c84b7e'] },
    { name: 'Bata', slug: 'bata', category: 'Retail / Fashion', gradient: ['#ff6b9d', '#c84b7e'] }
];

// Food brands
const foodBrands = [
    { name: "McDonald's", slug: 'mcdonalds', category: 'Food & Dining', gradient: ['#ff9a3c', '#e85a19'] },
    { name: 'KFC', slug: 'kfc', category: 'Food & Dining', gradient: ['#ff9a3c', '#e85a19'] },
    { name: "Domino's", slug: 'dominos', category: 'Food & Dining', gradient: ['#ff9a3c', '#e85a19'] },
    { name: 'Pizza Hut', slug: 'pizzahut', category: 'Food & Dining', gradient: ['#ff9a3c', '#e85a19'] },
    { name: 'Subway', slug: 'subway', category: 'Food & Dining', gradient: ['#ff9a3c', '#e85a19'] },
    { name: 'Starbucks', slug: 'starbucks', category: 'Food & Dining', gradient: ['#ff9a3c', '#e85a19'] },
    { name: 'Barbeque Nation', slug: 'bbq-nation', category: 'Food & Dining', gradient: ['#ff9a3c', '#e85a19'] },
    { name: 'Zomato', slug: 'zomato', category: 'Food & Dining', gradient: ['#ff9a3c', '#e85a19'] },
    { name: 'Swiggy', slug: 'swiggy', category: 'Food & Dining', gradient: ['#ff9a3c', '#e85a19'] },
    { name: 'Cafe Coffee Day', slug: 'ccd', category: 'Food & Dining', gradient: ['#ff9a3c', '#e85a19'] },
    { name: 'Burger King', slug: 'burger-king', category: 'Food & Dining', gradient: ['#ff9a3c', '#e85a19'] },
    { name: 'Wow! Momo', slug: 'wow-momo', category: 'Food & Dining', gradient: ['#ff9a3c', '#e85a19'] },
    { name: 'Taco Bell', slug: 'taco-bell', category: 'Food & Dining', gradient: ['#ff9a3c', '#e85a19'] }
];

// Entertainment brands
const entertainmentBrands = [
    { name: 'Netflix', slug: 'netflix', category: 'Entertainment & OTT', gradient: ['#7850ff', '#4a2dbd'] },
    { name: 'Amazon Prime', slug: 'amazon-prime', category: 'Entertainment & OTT', gradient: ['#7850ff', '#4a2dbd'] },
    { name: 'Disney+ Hotstar', slug: 'hotstar', category: 'Entertainment & OTT', gradient: ['#7850ff', '#4a2dbd'] },
    { name: 'Sony LIV', slug: 'sony-liv', category: 'Entertainment & OTT', gradient: ['#7850ff', '#4a2dbd'] },
    { name: 'Zee5', slug: 'zee5', category: 'Entertainment & OTT', gradient: ['#7850ff', '#4a2dbd'] },
    { name: 'Spotify', slug: 'spotify', category: 'Entertainment & OTT', gradient: ['#7850ff', '#4a2dbd'] },
    { name: 'Google Play', slug: 'google-play', category: 'Entertainment & OTT', gradient: ['#7850ff', '#4a2dbd'] },
    { name: 'PlayStation', slug: 'playstation', category: 'Entertainment & OTT', gradient: ['#7850ff', '#4a2dbd'] },
    { name: 'Xbox', slug: 'xbox', category: 'Entertainment & OTT', gradient: ['#7850ff', '#4a2dbd'] },
    { name: 'Steam', slug: 'steam', category: 'Entertainment & OTT', gradient: ['#7850ff', '#4a2dbd'] },
    { name: 'BookMyShow', slug: 'bookmyshow', category: 'Entertainment & OTT', gradient: ['#7850ff', '#4a2dbd'] },
    { name: 'PVR', slug: 'pvr', category: 'Entertainment & OTT', gradient: ['#7850ff', '#4a2dbd'] },
    { name: 'INOX', slug: 'inox', category: 'Entertainment & OTT', gradient: ['#7850ff', '#4a2dbd'] }
];

// Travel brands
const travelBrands = [
    { name: 'MakeMyTrip', slug: 'makemytrip', category: 'Travel & Hotels', gradient: ['#38bdf8', '#0369a1'] },
    { name: 'Yatra', slug: 'yatra', category: 'Travel & Hotels', gradient: ['#38bdf8', '#0369a1'] },
    { name: 'Goibibo', slug: 'goibibo', category: 'Travel & Hotels', gradient: ['#38bdf8', '#0369a1'] },
    { name: 'OYO', slug: 'oyo', category: 'Travel & Hotels', gradient: ['#38bdf8', '#0369a1'] },
    { name: 'Airbnb', slug: 'airbnb', category: 'Travel & Hotels', gradient: ['#38bdf8', '#0369a1'] },
    { name: 'Cleartrip', slug: 'cleartrip', category: 'Travel & Hotels', gradient: ['#38bdf8', '#0369a1'] },
    { name: 'EaseMyTrip', slug: 'easemytrip', category: 'Travel & Hotels', gradient: ['#38bdf8', '#0369a1'] },
    { name: 'Thomas Cook', slug: 'thomas-cook', category: 'Travel & Hotels', gradient: ['#38bdf8', '#0369a1'] },
    { name: 'Club Mahindra', slug: 'club-mahindra', category: 'Travel & Hotels', gradient: ['#38bdf8', '#0369a1'] },
    { name: 'Taj Hotels', slug: 'taj-hotels', category: 'Travel & Hotels', gradient: ['#38bdf8', '#0369a1'] },
    { name: 'ITC Hotels', slug: 'itc-hotels', category: 'Travel & Hotels', gradient: ['#38bdf8', '#0369a1'] },
    { name: 'Treebo', slug: 'treebo', category: 'Travel & Hotels', gradient: ['#38bdf8', '#0369a1'] },
    { name: 'FabHotels', slug: 'fabhotels', category: 'Travel & Hotels', gradient: ['#38bdf8', '#0369a1'] }
];

// E-commerce brands
const ecommerceBrands = [
    { name: 'Amazon', slug: 'amazon', category: 'E-Commerce', gradient: ['#fbbf24', '#d97706'] },
    { name: 'Flipkart', slug: 'flipkart', category: 'E-Commerce', gradient: ['#fbbf24', '#d97706'] },
    { name: 'Myntra', slug: 'myntra', category: 'E-Commerce', gradient: ['#fbbf24', '#d97706'] },
    { name: 'Snapdeal', slug: 'snapdeal', category: 'E-Commerce', gradient: ['#fbbf24', '#d97706'] },
    { name: 'Tata CLiQ', slug: 'tata-cliq', category: 'E-Commerce', gradient: ['#fbbf24', '#d97706'] },
    { name: 'Nykaa', slug: 'nykaa', category: 'E-Commerce', gradient: ['#fbbf24', '#d97706'] },
    { name: 'FirstCry', slug: 'firstcry', category: 'E-Commerce', gradient: ['#fbbf24', '#d97706'] },
    { name: 'Pepperfry', slug: 'pepperfry', category: 'E-Commerce', gradient: ['#fbbf24', '#d97706'] },
    { name: 'BigBasket', slug: 'bigbasket', category: 'E-Commerce', gradient: ['#fbbf24', '#d97706'] },
    { name: 'Reliance Digital', slug: 'reliance-digital', category: 'E-Commerce', gradient: ['#fbbf24', '#d97706'] },
    { name: 'Ajio', slug: 'ajio', category: 'E-Commerce', gradient: ['#fbbf24', '#d97706'] },
    { name: 'Meesho', slug: 'meesho', category: 'E-Commerce', gradient: ['#fbbf24', '#d97706'] },
    { name: 'Shopclues', slug: 'shopclues', category: 'E-Commerce', gradient: ['#fbbf24', '#d97706'] }
];

// Beauty brands
const beautyBrands = [
    { name: 'Sephora', slug: 'sephora', category: 'Beauty & Personal Care', gradient: ['#ec4899', '#be185d'] },
    { name: 'Nykaa Luxe', slug: 'nykaa-luxe', category: 'Beauty & Personal Care', gradient: ['#ec4899', '#be185d'] },
    { name: 'The Body Shop', slug: 'body-shop', category: 'Beauty & Personal Care', gradient: ['#ec4899', '#be185d'] },
    { name: 'Kama Ayurveda', slug: 'kama-ayurveda', category: 'Beauty & Personal Care', gradient: ['#ec4899', '#be185d'] },
    { name: 'Forest Essentials', slug: 'forest-essentials', category: 'Beauty & Personal Care', gradient: ['#ec4899', '#be185d'] },
    { name: 'Sugar Cosmetics', slug: 'sugar', category: 'Beauty & Personal Care', gradient: ['#ec4899', '#be185d'] },
    { name: 'Lakmé', slug: 'lakme', category: 'Beauty & Personal Care', gradient: ['#ec4899', '#be185d'] },
    { name: 'Mamaearth', slug: 'mamaearth', category: 'Beauty & Personal Care', gradient: ['#ec4899', '#be185d'] },
    { name: 'Plum', slug: 'plum', category: 'Beauty & Personal Care', gradient: ['#ec4899', '#be185d'] },
    { name: 'Colorbar', slug: 'colorbar', category: 'Beauty & Personal Care', gradient: ['#ec4899', '#be185d'] },
    { name: 'MAC', slug: 'mac', category: 'Beauty & Personal Care', gradient: ['#ec4899', '#be185d'] },
    { name: 'Maybelline', slug: 'maybelline', category: 'Beauty & Personal Care', gradient: ['#ec4899', '#be185d'] },
    { name: "L'Oréal", slug: 'loreal', category: 'Beauty & Personal Care', gradient: ['#ec4899', '#be185d'] }
];

// Fitness brands
const fitnessBrands = [
    { name: 'Cult.fit', slug: 'cultfit', category: 'Fitness & Wellness', gradient: ['#10b981', '#047857'] },
    { name: 'HealthKart', slug: 'healthkart', category: 'Fitness & Wellness', gradient: ['#10b981', '#047857'] },
    { name: "Gold's Gym", slug: 'golds-gym', category: 'Fitness & Wellness', gradient: ['#10b981', '#047857'] },
    { name: 'Talwalkars', slug: 'talwalkars', category: 'Fitness & Wellness', gradient: ['#10b981', '#047857'] },
    { name: 'Anytime Fitness', slug: 'anytime-fitness', category: 'Fitness & Wellness', gradient: ['#10b981', '#047857'] },
    { name: 'Snap Fitness', slug: 'snap-fitness', category: 'Fitness & Wellness', gradient: ['#10b981', '#047857'] },
    { name: 'Fitness First', slug: 'fitness-first', category: 'Fitness & Wellness', gradient: ['#10b981', '#047857'] },
    { name: 'Yoga Bar', slug: 'yoga-bar', category: 'Fitness & Wellness', gradient: ['#10b981', '#047857'] },
    { name: 'The Yoga Institute', slug: 'yoga-institute', category: 'Fitness & Wellness', gradient: ['#10b981', '#047857'] },
    { name: 'Fitpass', slug: 'fitpass', category: 'Fitness & Wellness', gradient: ['#10b981', '#047857'] },
    { name: 'Fitternity', slug: 'fitternity', category: 'Fitness & Wellness', gradient: ['#10b981', '#047857'] },
    { name: 'GymNation', slug: 'gymnation', category: 'Fitness & Wellness', gradient: ['#10b981', '#047857'] },
    { name: 'SquatWolf', slug: 'squatwolf', category: 'Fitness & Wellness', gradient: ['#10b981', '#047857'] }
];

// Home brands
const homeBrands = [
    { name: 'Croma', slug: 'croma', category: 'Home & Electronics', gradient: ['#64748b', '#334155'] },
    { name: 'Vijay Sales', slug: 'vijay-sales', category: 'Home & Electronics', gradient: ['#64748b', '#334155'] },
    { name: 'IKEA', slug: 'ikea', category: 'Home & Electronics', gradient: ['#64748b', '#334155'] },
    { name: 'Urban Ladder', slug: 'urban-ladder', category: 'Home & Electronics', gradient: ['#64748b', '#334155'] },
    { name: 'Home Centre', slug: 'home-centre', category: 'Home & Electronics', gradient: ['#64748b', '#334155'] },
    { name: 'Havells', slug: 'havells', category: 'Home & Electronics', gradient: ['#64748b', '#334155'] },
    { name: 'Philips', slug: 'philips', category: 'Home & Electronics', gradient: ['#64748b', '#334155'] },
    { name: 'LG', slug: 'lg', category: 'Home & Electronics', gradient: ['#64748b', '#334155'] },
    { name: 'Samsung', slug: 'samsung', category: 'Home & Electronics', gradient: ['#64748b', '#334155'] },
    { name: 'Sony', slug: 'sony', category: 'Home & Electronics', gradient: ['#64748b', '#334155'] },
    { name: 'Whirlpool', slug: 'whirlpool', category: 'Home & Electronics', gradient: ['#64748b', '#334155'] },
    { name: 'Godrej', slug: 'godrej', category: 'Home & Electronics', gradient: ['#64748b', '#334155'] },
    { name: 'Bosch', slug: 'bosch', category: 'Home & Electronics', gradient: ['#64748b', '#334155'] }
];

// Education brands
const educationBrands = [
    { name: 'Udemy', slug: 'udemy', category: 'Education', gradient: ['#6366f1', '#3730a3'] },
    { name: 'Coursera', slug: 'coursera', category: 'Education', gradient: ['#6366f1', '#3730a3'] },
    { name: "Byju's", slug: 'byjus', category: 'Education', gradient: ['#6366f1', '#3730a3'] },
    { name: 'Unacademy', slug: 'unacademy', category: 'Education', gradient: ['#6366f1', '#3730a3'] },
    { name: 'Simplilearn', slug: 'simplilearn', category: 'Education', gradient: ['#6366f1', '#3730a3'] },
    { name: 'upGrad', slug: 'upgrad', category: 'Education', gradient: ['#6366f1', '#3730a3'] },
    { name: 'Great Learning', slug: 'great-learning', category: 'Education', gradient: ['#6366f1', '#3730a3'] },
    { name: 'Vedantu', slug: 'vedantu', category: 'Education', gradient: ['#6366f1', '#3730a3'] },
    { name: 'Toppr', slug: 'toppr', category: 'Education', gradient: ['#6366f1', '#3730a3'] },
    { name: 'Khan Academy', slug: 'khan-academy', category: 'Education', gradient: ['#6366f1', '#3730a3'] },
    { name: 'Skillshare', slug: 'skillshare', category: 'Education', gradient: ['#6366f1', '#3730a3'] },
    { name: 'LinkedIn Learning', slug: 'linkedin-learning', category: 'Education', gradient: ['#6366f1', '#3730a3'] },
    { name: 'Pluralsight', slug: 'pluralsight', category: 'Education', gradient: ['#6366f1', '#3730a3'] }
];

// Utility brands
const utilityBrands = [
    { name: 'Uber', slug: 'uber', category: 'Misc / Utility', gradient: ['#14b8a6', '#0f766e'] },
    { name: 'Ola', slug: 'ola', category: 'Misc / Utility', gradient: ['#14b8a6', '#0f766e'] },
    { name: 'Paytm', slug: 'paytm', category: 'Misc / Utility', gradient: ['#14b8a6', '#0f766e'] },
    { name: 'PhonePe', slug: 'phonepe', category: 'Misc / Utility', gradient: ['#14b8a6', '#0f766e'] },
    { name: 'Google Pay', slug: 'google-pay', category: 'Misc / Utility', gradient: ['#14b8a6', '#0f766e'] },
    { name: 'Rapido', slug: 'rapido', category: 'Misc / Utility', gradient: ['#14b8a6', '#0f766e'] },
    { name: 'Dunzo', slug: 'dunzo', category: 'Misc / Utility', gradient: ['#14b8a6', '#0f766e'] },
    { name: 'Urban Company', slug: 'urban-company', category: 'Misc / Utility', gradient: ['#14b8a6', '#0f766e'] },
    { name: 'Housejoy', slug: 'housejoy', category: 'Misc / Utility', gradient: ['#14b8a6', '#0f766e'] },
    { name: 'Justdial', slug: 'justdial', category: 'Misc / Utility', gradient: ['#14b8a6', '#0f766e'] },
    { name: 'Sulekha', slug: 'sulekha', category: 'Misc / Utility', gradient: ['#14b8a6', '#0f766e'] },
    { name: 'Quikr', slug: 'quikr', category: 'Misc / Utility', gradient: ['#14b8a6', '#0f766e'] },
    { name: 'OLX', slug: 'olx', category: 'Misc / Utility', gradient: ['#14b8a6', '#0f766e'] }
];

// Generate all coupons
export const allCoupons = [
    ...generateCoupons(fashionBrands, 'fashion', DISCOUNT_RATES.fashion),
    ...generateCoupons(foodBrands, 'food', DISCOUNT_RATES.food),
    ...generateCoupons(entertainmentBrands, 'entertainment', DISCOUNT_RATES.entertainment),
    ...generateCoupons(travelBrands, 'travel', DISCOUNT_RATES.travel),
    ...generateCoupons(ecommerceBrands, 'ecommerce', DISCOUNT_RATES.ecommerce),
    ...generateCoupons(beautyBrands, 'beauty', DISCOUNT_RATES.beauty),
    ...generateCoupons(fitnessBrands, 'fitness', DISCOUNT_RATES.fitness),
    ...generateCoupons(homeBrands, 'home', DISCOUNT_RATES.home),
    ...generateCoupons(educationBrands, 'education', DISCOUNT_RATES.education),
    ...generateCoupons(utilityBrands, 'utility', DISCOUNT_RATES.utility)
];

export const couponCategories = [
    { key: 'fashion', name: 'Retail / Fashion', icon: '🛍️' },
    { key: 'food', name: 'Food & Dining', icon: '🍔' },
    { key: 'entertainment', name: 'Entertainment & OTT', icon: '🎬' },
    { key: 'travel', name: 'Travel & Hotels', icon: '✈️' },
    { key: 'ecommerce', name: 'E-Commerce', icon: '🛒' },
    { key: 'beauty', name: 'Beauty & Personal Care', icon: '💄' },
    { key: 'fitness', name: 'Fitness & Wellness', icon: '🏋️' },
    { key: 'home', name: 'Home & Electronics', icon: '🏠' },
    { key: 'education', name: 'Education', icon: '📚' },
    { key: 'utility', name: 'Misc / Utility', icon: '🚗' }
];

export default allCoupons;
